<template>
  <v-container id="pacote-list">
    <v-row>
      <v-col>Contratos</v-col>
      <v-col class="text-right">
        <app-modal-insert-eixo
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadPacotes"
        >
          <template v-slot:title :edit="false">
            Cadastro de Contratos
          </template>
        </app-modal-insert-eixo>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col>
                <app-modal-insert-eixo
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadPacotes"
                >
                  <template v-slot:title> Edição de Contratos </template>
                </app-modal-insert-eixo>
              </v-col>
              <v-col>
                <app-modal-delete :object="item" @on-save="loadPacotes">
                  <template v-slot:title>
                    {{ item.ativo ? "Inativar" : "Reativar" }} Contrato
                  </template>
                </app-modal-delete>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.inicio="{ item }">
            {{ item.inicio | moment("DD/MM/YYYY") }}
          </template>
          <template v-slot:item.fim="{ item }">
            {{ item.fim | moment("DD/MM/YYYY") }}
          </template>

          <template v-slot:item.ativo="{ item }">
            <div
              :class="{
                ativo: item.ativo,
                inativo: !item.ativo,
                status: true,
              }"
            >
              {{ item.ativo ? "Ativo" : "Inativo" }}
            </div>
          </template>
          <template slot="no-data">
            <span> Nenhum Contrato retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertEixo from "./ModalInsert";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalStatus";
import moment from "moment";
import { contratosAPI } from "@/apis";

export default {
  components: {
    AppModalInsertEixo,
    AppModalDelete,
  },
  data() {
    return {
      headers: [
        { text: "N° Contrato", value: "numContrato" },
        { text: "Inicio", value: "inicio", sortable: false },
        { text: "Fim", value: "fim", sortable: false },
        { text: "Responsável", value: "usuario.nome", sortable: false },
        { text: "Situação", value: "ativo", sortable: false },
        { text: "Ações", value: "acoes", sortable: false },
      ],
      payload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),

    loadPacotes() {
      this.setLoading(true);

      contratosAPI[this.isFullAdmin ? "list" : "listByUser"](
        this.user.usuarioId
      )
        .then((resp) => {
          this.payload = resp.data;

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Contratos");
        });
    },
  },
  mounted() {
    this.loadPacotes();
  },

  computed: {
    ...mapGetters(["isFullAdmin", "user"]),
  },
};
</script>
<style lang="scss" scoped>
.status {
  padding: 5px 10px;
  text-align: center;
  border-radius: 10px;
  width: fit-content;
  width: 100px;
}

.ativo {
  background-color: #0080003b;
  border: 1px solid #3aa93a;
  color: #0f2e0f;
}

.inativo {
  background-color: #ff000059;
  border: 1px solid red;
  color: #020202;
}
</style>
